import { AppStateManager } from "common/helpers/app-state-manager.utils";
import { useLocation, useNavigate } from "react-router-dom";

const useReopenNavigate = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const goBack = () => {
		const steps = AppStateManager.getReopenSteps();

		if (!steps) return console.error("Not step found");

		const visulizzableSteps = steps?.filter((x) => !x.hideOnMenu);

		const currentStepIndex = visulizzableSteps?.findIndex((x) => x.route == location.pathname);
		const previusStep = visulizzableSteps?.[currentStepIndex - 1]?.route;

		navigate(previusStep);
	};

	const goNext = () => {
		const steps = AppStateManager.getReopenSteps();

		if (!steps) return console.error("Not step found");

		const visulizzableSteps = steps?.filter((x) => !x.hideOnMenu);

		const currentStepIndex = visulizzableSteps?.findIndex((x) => x.route == location.pathname);
		const nextStep = visulizzableSteps?.[currentStepIndex + 1]?.route;

		navigate(nextStep);
	};

	return { goBack, goNext };
};
export default useReopenNavigate;
